import React from "react";

// ROUTER
import { Route, Switch } from "react-router-dom";
// ROUTER
// PAGES
import Inicio from "../pages/Inicio";
import Trivia from "../pages/Trivia";
import TriviaGame from "../pages/Trivia/TriviaGame";
import Crucigrama from "../pages/Crucigrama/";
import CrucigramaGame from "../pages/Crucigrama/CrucigramaGame";
import SopaLetras from "../pages/SopaLetras/SopaLetras";
import SopaLetrasGame from "../pages/SopaLetras/SopaLetrasGame";
// PAGES

export default function Router() {
  // VARIABLES

  return (
    <>
    <Switch>
      <Route path="/" exact>
        <Inicio />
      </Route>
      <Route path="/Trivia" exact>
        <Trivia />
      </Route>
      <Route path="/TGame" exact>
        <TriviaGame />
      </Route>
      <Route path="/Crucigrama" exact>
        <Crucigrama />
      </Route>
      <Route path="/CGame" exact>
        <CrucigramaGame />
      </Route>
      <Route path="/SopaDeLetras" exact>
        <SopaLetras />
      </Route>
      <Route path="/SGame" exact>
        <SopaLetrasGame />
      </Route>
      </Switch>
    </>
  );
}
